import {LightboxImage} from '@wandb/weave/components/PagePanelComponents/LightboxImage';
import React, {useEffect, useState} from 'react';

import {LoadingDots} from '../../../../../LoadingDots';
import {type ImageDim, loadImage} from '../../loadImage';
import {ValueViewPrimitive} from './ValueViewPrimitive';

type ValueViewImageProps = {
  value: string;
};

export const ValueViewImage = ({value}: ValueViewImageProps) => {
  const maxDim = 200;
  const [imageDim, setImageDim] = useState<ImageDim>({width: -1, height: -1});
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setImageDim({width: -1, height: -1});
    setHasError(false);
    loadImage(value, setImageDim, () => setHasError(true));
  }, [value]);

  if (hasError) {
    return <ValueViewPrimitive>Failed to load image</ValueViewPrimitive>;
  }
  if (imageDim.width === -1 || imageDim.height === -1) {
    return <LoadingDots />;
  }

  const maxImageDim = Math.max(imageDim.width, imageDim.height);
  const isThumbnail = maxImageDim > maxDim;
  const alt = `Logged image ${imageDim.width}x${imageDim.height}px`;
  if (!isThumbnail) {
    return <img src={value} alt={alt} />;
  }

  // Image was too big for space, show a thumbnail and open lightbox on click.
  const ratio = maxDim / maxImageDim;
  const w = imageDim.width * ratio;
  const h = imageDim.height * ratio;

  return <LightboxImage src={value} width={w} height={h} alt={alt} />;
};
